export default () => ({
  myFilesContainer: {
    padding: '0px 32px',
    marginRight: '0px !important',
  },
  '@media (max-width: 1024px)': {
    myFilesContainer: {
      padding: '0px 16px !important',
    },
  },
  myFilesWrapper: {
    border: '#08A383 3px solid',
    borderRadius: '35px',
    marginTop: '98px',
    marginBottom: '194px',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: '45px',
    background: 'white',
    paddingRight: '53px',//'3%',
    paddingLeft: '53px',//'3%',
    maxWidth:'1440px',
    // minWidth: ''
  },
  customTooltip: {
    border: '#03A383 1px solid',
  },
});
